import React from 'react';
import { Nav,Navbar,InputGroup, InputGroupAddon, ModalBody, Table, Form, Modal, Col, Input, Button, Container, Spinner } from 'reactstrap';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

export default class Clientes extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            cargando:true,
            formVisible: false,
            empresa:props.usuario.empresa,
            clave: '',
            nombre:'',
            objeto:{},
            regimenes:[],
            objetos: []
        };
        this.cargarCatalogos();
        this.cargarObjetos();
    }
    onFormClose = () => {
        this.setState({
            formVisible: false
        });
    }
    cargarCatalogos = async () => {
        this.setState({cargando:true});
        const url = `${this.props.urlws}/cliente/regimenes`;
        const resp = await fetch(url);
        const regimenes = await resp.json();
        this.setState({cargando:false, regimenes });
    }
    cargarObjetos = async () => {
        this.setState({cargando:true});
        const url = `${this.props.urlws}/cliente/lista?id=${this.state.empresa}&filtro=${this.state.nombre}`;
        const resp = await fetch(url);
        const objetos = await resp.json();
        this.setState({cargando:false, objetos });
    }
    onSubmit = (e) => {
        e.preventDefault();
        this.cargarObjetos();
    }
    onChange = (e) => {
        this.setState({ [e.target.name] : e.target.value});
    }
    onBntBuscarClick = () =>{
        this.cargarObjetos();
    }    
    cargar = async (id) => {
        this.setState({cargando:true});
        const url = this.props.urlws + "/cliente/cargar/" + id;
        const resp = await fetch(url);
        const objeto = await resp.json();
        objeto.Empresa = this.state.empresa;
        if(objeto.Id == 0){
           objeto.Usuario = this.props.usuario.id;
           objeto.Regimen = "?";
        }
         this.setState({
            cargando:false,
            formVisible: true,
            clave: id,
            objeto
        });
    }
    guardar = () =>{
        this.onFormClose();
        this.cargarObjetos();
    }
    nuevo = () => {
        this.cargar(-1);
    }
    imprimir = () =>{
        const url = `${this.props.urlws}/cliente/listaPdf`;
        window.open(url, '', '');
    }
    excel = () =>{
    }
    render() {
        const estilo = { display: this.state.formVisible ? 'none' : 'inline' };
        return (
            <Container style={{ padding: 10 }} >
                {this.state.cargando ?
                    <div className="loader">
                        <Spinner animation="border" color="primary" />
                    </div>
                    :
                    null
                }
                <div style={estilo}>
                    <div className="row">
                        <div className="col">
                            <Form inline onSubmit={this.onSubmit} >
                                <InputGroup>
                                    <Input size="sm" type="text" placeholder="Buscar" name="nombre" onChange={this.onChange} style={{ width: 400 }} />
                                    <InputGroupAddon addonType="append">
                                        <Button size="sm" color="success" onClick={this.onBntBuscarClick}> Buscar <img src="/imagenes/zoom.png" /> </Button>
                                    </InputGroupAddon>
                                    &nbsp;
                                    &nbsp;
                                    <Button size="sm" color="success" outline onClick={this.nuevo}><img src="/imagenes/add.png" /></Button>
                                    &nbsp;
                                    &nbsp;
                                    <Button size="sm" color="success" outline onClick={this.imprimir}><img src="/imagenes/printer.png" /></Button>
                                    &nbsp;
                                    <Button size="sm" color="success" outline onClick={this.excel}><img src="/imagenes/excel.png" /></Button>
                                </InputGroup>
                            </Form>
                        </div>
                    </div>
                    <div style={{ height: 4 }}></div>
                    <ObjetoTable objetos={this.state.objetos} height={500} width={990} onRowClick={this.cargar} />
                </div>
                <ObjetoForm urlws={this.props.urlws} visible={this.state.formVisible} objeto={this.state.objeto} regimenes={this.state.regimenes} onClose={this.onFormClose} clave={this.state.clave} guardar={this.guardar} />
            </Container>
        );
    }
}

class ObjetoTable extends React.Component {
    onRowClick = (cve) => {
        this.props.onRowClick(cve);
    }
    render() {
        let { objetos } = this.props;
        return (
            <div style={{ height: this.props.height, width:this.props.width, overflow: 'auto' }}>
            <Table striped bordered hover size="sm">
                <thead>
                    <tr>
                        <th style={{width:50}}>Id</th>
                        <th>Nombre</th>
                        <th style={{width:60, textAlign:'center'}}>Activo</th>
                        <th style={{width:30}}></th>
                    </tr>
                </thead>
                <tbody>
                    {objetos.map((o, i) => (
                        <ObjetoRow key={i} objeto={o} onRowClick={this.onRowClick} />
                    ))}
                </tbody>
                </Table>
            </div>
        );
    }
}

class ObjetoRow extends React.Component{
    onClick = (e) =>{
        this.props.onRowClick(this.props.objeto.I);
    }
    render(){
        let {objeto} = this.props;
        return (
        <tr>
            <td>{objeto.I}</td>
            <td>{objeto.N}</td>
            <td style={{textAlign:'center'}}><input type="checkbox" checked={objeto.A}/></td>
            <td>
                <img src="/imagenes/edit.png" onClick={this.onClick} alt="editar" title="editar"/>
            </td>
        </tr>
        );
    }
}

class ObjetoForm extends React.Component {
    constructor(props){
        super(props);
        let obj = props.objeto;
        this.state = {
            objeto:obj,
            cargando:false,
            mostrarDialogo:false,
            recargarAcst:false,
            acts:[]
        };
    }
    componentWillReceiveProps(newProps){
        let obj = newProps.objeto;
        this.setState({
            objeto:obj,
            cargando:false,
            mostrarDialogo:false,
            recargarAcst:false,
            acts:[]
        });
    }
    onChange = (e) => {
        const campo = e.target.name;
        const obj = {
            ...this.state.objeto,
            [campo] : e.target.value
        };
        this.setState({objeto:obj});
    }
    onChecked = (e) => {
        const campo = e.target.name;
        const obj = {
            ...this.state.objeto,
            [campo] : e.target.checked
        };
        this.setState({objeto:obj});
    }
    cargarActividades = async() =>{
        const cte = this.state.objeto.Id;
        this.setState({cargando:true});
        const url = `${this.props.urlws}/actividad/listaCliente/${cte}?todas=N`;
        const resp = await fetch(url);
        this.state.objeto.Actividades = await resp.json();
        this.setState({cargando:false});
    }
    onSel = async(i) => {
        const cte = this.state.objeto.Id;
        const act = this.state.acts[i].I;
        const sta = !this.state.acts[i].A;
        const val = sta ? "S":"N";
        this.setState({cargando:true});
        const url = `${this.props.urlws}/cliente/guardarAct/${cte}?act=${act}&val=${val}`;
        const resp = await fetch(url);
        const res = await resp.text();
        if(res.substring(0,3) !== "Err"){
            this.state.acts[i].A = sta;
            this.state.recargarAcst = true;
            this.setState({cargando:false});
        }
        else{
            this.setState({cargando:false});
            Swal.fire('Atencion',res,'error');
        }
    }
    guardar = () =>{
        if(this.state.objeto.Regimen == "?"){
            Swal.fire('Atencion','Especifique el regimen','success');
            return;
        }
        const MySwal = withReactContent(Swal)
        MySwal.fire({
            title: 'Confirme',
            text: "¿ Desea guardar estos datos ?",
            type: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            cancelButtonText: 'No',
            confirmButtonText: 'Si'
          }).then((result) => {
            if (result.value) {
                this.guardarB(this.state.objeto);
            }
          })        
    }
    guardarB = async(dato) =>{
        const url = this.props.urlws +"/cliente/wsGuardar";
        this.setState({cargando:true});
        if(dato.Codigo === 0)
           dato.Codigo = '';
        const json = JSON.stringify(dato);
        const resp = await fetch(url,{
            method: 'POST', // or 'PUT'
            body: json // data can be `string` or {object}!
          });
        const res = await resp.text();
        this.setState({cargando:false});
        if(res.substring(0,3) !== "Err"){
            Swal.fire('Atencion','Datos guardados','success');
            this.props.guardar();
        }
        else
            Swal.fire('Atencion',res,'error');
    }
    editarActs = async () =>{
        this.setState({cargando:true, recargarAcst:false});
        const url = `${this.props.urlws}/actividad/listaCliente/${this.state.objeto.Id}?todas=S`;
        const resp = await fetch(url);
        const acts = await resp.json();
        this.setState({mostrarDialogo:true, cargando:false, acts});
    }
    handleClose = () =>{
        if(this.state.recargarAcst)
           this.cargarActividades();
        this.setState({mostrarDialogo:false, recargarAcst:false});
    }
    render() {
        const estilo = { display: this.props.visible ? 'inline' : 'none'};
        if(this.props.objeto === undefined)
            return null;
        if(Object.keys(this.props.objeto).length === 0)
            return null;
        let id = this.state.objeto.Id;
        if(id == 0)
           id = "NUEVO";
        return (
            <Container style={estilo}>
                {this.state.cargando ?
                    <div className="loader">
                        <Spinner animation="border" color="primary" />
                    </div>
                    :
                    null
                }
                <Form>
                    <div className="row">
                        <div className="col-1">
                            <span>Id</span><br />
                            <Input size="sm" type="text" name="Codigo" value={id} />
                        </div>
                        {' '}
                        <div className="col">
                            <span>Nombre</span><br />
                            <Input size="sm" type="text" name="Nombre" value={this.state.objeto.Nombre} onChange={this.onChange} />
                        </div>
                        <div className="col-2">
                            <span>R.F.C.</span><br />
                            <Input size="sm" type="text" name="Rfc" value={this.state.objeto.Rfc} onChange={this.onChange} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <span>Direccion</span><br />
                            <Input size="sm" type="text" name="Direccion" value={this.state.objeto.Direccion} onChange={this.onChange} />
                        </div>
                        <div className="col-5">
                            <span>Poblacion</span><br />
                            <Input size="sm" type="text" name="Poblacion" value={this.state.objeto.Poblacion} onChange={this.onChange} />
                        </div>
                        <div className="col-1">
                            <span>C.P.</span><br />
                            <Input size="sm" type="text" name="CP" value={this.state.objeto.CP} onChange={this.onChange} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <span>Email</span><br />
                            <Input size="sm" type="text" name="Email" value={this.state.objeto.Email} onChange={this.onChange} />
                        </div>
                        <div className="col">
                            <span>Telefono</span><br />
                            <Input size="sm" type="text" name="Telefono" value={this.state.objeto.Telefono} onChange={this.onChange} />
                        </div>
                        <div className="col">
                            <span>Contacto</span><br />
                            <Input size="sm" type="text" name="Contacto" value={this.state.objeto.Contacto} onChange={this.onChange} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-5">
                            <span>Regimen</span>
                            <Input size="sm" type="select" name="Regimen" value={this.state.objeto.Regimen} onChange={this.onChange}>
                                <option key={0} value="?">Especifique</option>
                                {this.props.regimenes.map((i, k) =>
                                    <option key={i.I} value={i.I}>{i.N}</option>
                                )}
                            </Input>
                        </div>
                        <div className="col-2">
                            <span>Activo</span><br />
                            <input type="checkbox" name="Activo" checked={this.state.objeto.Activo} onChange={this.onChecked} />
                        </div>
                        <div className="col-1">
                            <br/>
                            <span>Actividades</span>
                        </div>
                        <div className="col-3">
                            <br/>
                            <Button size="sm" color="warning" onClick={this.editarActs}> Editar <img src="/imagenes/edit.png" /> </Button>
                        </div>
                    </div>
                </Form>
                <br />
                <div className="row">
                    <div className="col">
                        <Button size="sm" color="success" onClick={this.guardar}>Aceptar</Button>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <Button size="sm" color="danger" onClick={this.props.onClose}>Cancelar</Button>
                    </div>
                    <div className="col-8">
                        <Table striped bordered hover size="sm">
                            <thead>
                                <tr>
                                <th style={{ width: 250 }}>Servicio</th>
                                    <th>Actividad</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.objeto.Actividades.map((o, i) => (
                                    <tr>
                                        <tr style={{ width: 250 }}>{o.M}</tr>
                                        <td>{o.N}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                </div>
                <Modal size="lg" id="dlgActs" name="dlgActs" isOpen={this.state.mostrarDialogo} toggle={this.handleClose}>
                    <ModalBody>
                        <h5>Actividades</h5>
                        <Table striped bordered hover size="sm">
                            <thead>
                                <tr>
                                <th style={{ width: 300 }}>Servicio</th>
                                <th>Actividad</th>
                                <th style={{width:30}}></th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.acts.map((o, i) => (
                                    <tr>
                                        <tr style={{ width: 300 }}>{o.M}</tr>
                                        <td>{o.N}</td>
                                        <td style={{textAlign:'center'}}>
                                            <input type="checkbox" checked={o.A} onChange={()=> this.onSel(i)}/>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </ModalBody>
                </Modal> 
            </Container>
        );
    }
}